import { useEffect, useState } from "react";
import RequestApi from "./services";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Snackbar from "@mui/material/Snackbar";
import Stack from "@mui/material/Stack";
import Alert from "@mui/material/Alert";

const CompanyRequest = () => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  const [message, setMessage] = useState(true);
  const [severity, setSeverity] = useState("error");
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const handleClose = () => {
    setShow(false);
    setOpen(false);
  };
  const schema = {
    requestId: "",
    name: "",
    emailAddress: "",
    phoneNo: "",
    ssn: "",
    companyName: "",
    languageSkills: "",
    emergencyNumber: "",
    allData: "",
  };
  const [getData, setGetdata] = useState(schema);
  const handleShow = (
    requestId,
    name,
    email,
    phoneNo,
    ssn,
    company,
    languageSkills,
    emergencyNumber,
    allData
  ) => {
    setShow(true);
    setGetdata({
      ...getData,
      requestId: requestId,
      fullName: name,
      emailAddress: email,
      phoneNo: phoneNo,
      ssn: ssn,
      company: company,
      languageSkills: languageSkills,
      emergencyNumber: emergencyNumber,
      allData: allData,
    });
  };
  function getWorkerRequest() {
    debugger;
    RequestApi.getWorkerRequest().then((respons) => {
      setData(respons.data.data);
      console.log("getWorkerRequest", respons.data.data);
    });
  }

  function workerAprroval(requestId, status) {
    navigate("/dashboard/company/addwoker", {
      state: { ...getData.allData, requestId: requestId, status: status },
    });
  }
  function workerReject(requestId, status) {
    debugger;
    RequestApi.workerAprroval(requestId, status).then((response) => {
      console.log(response);
      setMessage(response.data.message);
      setSeverity("success");
      setOpen(true);
      setShow(false);
      getWorkerRequest();
    });
  }

  // function testApi() {
  //    var fileInput = document.getElementById('fileInput');
  //    var file = fileInput.files[0];
  //    console.log("fileInput", file)
  //    const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRhIjp7Il9pZCI6IjY1ZDg4NmUzZjRlNWM1ZTE4OTA2NzRhMyIsImZpcnN0TmFtZSI6IkF5dXNoIiwibGFzdE5hbWUiOiJzZW5nYXIiLCJlbWFpbCI6ImF5dXNoQGdtYWlsLmNvbSIsInBob25lIjo2NTQ5ODczMjEwLCJnZW5kZXIiOiJtYWxlIiwic3RhdGUiOiJkZWxoaSIsImNpdHkiOiJuZXcgZGVsaGkiLCJob2JiaWVzIjoic29uZyIsImRvYiI6IjAxLzA0LzE5OTYifSwiaWF0IjoxNzA4Njg5MTU4LCJleHAiOjE3MDg2OTI3NTh9.gLuB_m2zrjGkiFfGOp5ynBTKIX9QEk119Yqiqz7MrmA';
  //    const formdata = new FormData();
  //    formdata.append("firstName", "Ayush");
  //    formdata.append("lastName", "sengar");
  //    formdata.append("email", "ayush@gmail.com");
  //    formdata.append("phone", "6549873210");
  //    formdata.append("gender", "male");
  //    formdata.append("state", "delhi");
  //    formdata.append("city", "new delhi");
  //    formdata.append("hobbies", "song");
  //    formdata.append("dob", "01/04/1996");
  //    formdata.append("password", "Admin@123");
  //    formdata.append("photo", file);
  //    //fetch('http://18.234.198.7:5000/api/auth/signUp', {
  //    //fetch('http://18.234.198.7:5000/api/auth/login', {
  //    //fetch('http://18.234.198.7:5000/api/auth/users', {
  //    fetch('http://18.234.198.7:5000/api/city/list', {
  //       //fetch('http://18.234.198.7:5000/api/auth/deleteUser/65d886e3f4e5c5e1890674a3', {
  //       // fetch('http://44.201.126.35:5000/api/auth/deleteUser/65d886e3f4e5c5e1890674a3', {
  //       method: 'GET',
  //       headers: {
  //          // 'Authorization': `Bearer ${token}`
  //          // "Content-Type": "application/json"
  //       },
  //       // body: JSON.stringify({ "email": "ayush@gmail.com", "password": "Admin@123" }),
  //       // body: formdata,
  //    }
  //    )
  //       .then((respon) => {
  //          respon.json().then((result) => {
  //             console.log("testApi", result)
  //          })
  //       })
  //       .catch(error => {
  //          console.error('There was a problem with the fetch operation:', error);
  //       })
  // }

  useEffect(() => {
    getWorkerRequest();
    //testApi()
  }, []);
  return (
    <>
      <div className="card radius-10 p-4 px-3">
        <div className="card-header bg-transparent border-0">
          <div className="row g-3 align-items-center">
            <div className="col-6 col-md-6 col-lg-3">
              <h5 className="mb-0">{t("Worker_Requests")}</h5>
              {/* <input type="file" name="fileInput" id="fileInput" />
                     <button type="button" onClick={testApi}>Upload</button> */}
            </div>

            <div className="col-6 col-md-6 col-lg-9">
              {/* <div className="text-right">
                <button
                  className="btn btn-outline-secondary dropdown-toggle btn-blue px-3"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  All
                </button>
                <ul className="dropdown-menu dropdown-menu-end border-b">
                  <li>
                    <a className="dropdown-item" href="#">
                      All
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="#">
                      Approved
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="#">
                      Rejected
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="#">
                      Pending
                    </a>
                  </li>
                </ul>
              </div> */}
            </div>
          </div>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col py-2">
              {data.length > 0 ? (
                data.map((item) => (
                  <div className="card radius-15">
                    <div className="card-body card-border align-items-center">
                      <div className="float-end text-dark">
                        <button
                          type="button"
                          className="btn btn-primary px-3 font-14"
                          onClick={() =>
                            handleShow(
                              item.requestId,
                              item.fullName,
                              item.emailAddress,
                              item.phoneNo,
                              item.ssn,
                              item.companyResponse.companyName,
                              item.languageSkills,
                              item.emergencyNumber,
                              item
                            )
                          }
                        >
                          View Details
                        </button>
                      </div>

                      <p className="card-text pt-1">
                        {item.fullName} has requested for credentials to login
                      </p>
                    </div>
                  </div>
                ))
              ) : (
                <p>No Request Found</p>
              )}
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Request for Credential</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-12 col-lg-12 col-xl-12 mb-3">
              <div className="px-4 pt-3 text-center">
                <h6 className="font-20 text-dark  text-center">
                  {getData.fullName}
                </h6>
              </div>
              <div className="px-lg-4 pt-4 px-3">
                <div className="row">
                  <div className="col-md-6 col-12  mb-3">
                    <label className="font-14">Full name</label>
                    <div className="border-bottom2 height-50">
                      <span className="font-14 text-dark ">
                        {" "}
                        {getData.fullName}
                      </span>
                    </div>
                  </div>
                  <div className="col-md-6 col-12  mb-3">
                    <label className="font-14">Email Address</label>
                    <div className="border-bottom2 height-50">
                      <span className="font-14 text-dark ">
                        {" "}
                        {getData.emailAddress}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 col-12  mb-3">
                    <label className="font-14">Phone number</label>
                    <div className="border-bottom2 height-50">
                      <span className="font-14 text-dark">
                        {getData.phoneNo}
                      </span>
                    </div>
                  </div>
                  <div className="col-md-6 col-12  mb-3">
                    <label className="font-14">Social Security number</label>
                    <div className="border-bottom2 height-50">
                      <span className="font-14 text-dark ">{getData.ssn}</span>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 col-12  mb-3">
                    <label className="font-14">Company name</label>
                    <div className="border-bottom2 height-50">
                      <span className="font-14 text-dark ">
                        {getData.company}
                      </span>
                    </div>
                  </div>

                  <div className="col-md-6 col-12  mb-3">
                    <label className="font-14">Emergency number</label>
                    <div className="border-bottom2 height-50">
                      <span className="font-14 text-dark text-right ">
                        {" "}
                        {getData.emergencyNumber}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="row text-center mt-4">
                  <div className="col-md-12 col-12  mb-3">
                    {/* <Link to="/dashboard/company/addwoker" state={{ ...getData.allData }} className="btn btn-primary px-3 px-3 w-50">Register Employee</Link> */}
                    <Button
                      className="btn btn-primary px-3 px-3 w-50"
                      onClick={() => workerAprroval(getData.requestId, true)}
                    >
                      Register Worker
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button
            variant="danger"
            onClick={() => workerReject(getData.requestId, false)}
          >
            Reject
          </Button>
        </Modal.Footer>
      </Modal>

      <div
        className="modal fade"
        id="exampleModal2"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
          <div className="modal-content">
            <div className="modal-header border-0 mb-0 p-3 pb-0">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body font-20 text-dark px-4"></div>
          </div>
        </div>
      </div>
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={open}
          autoHideDuration={2000}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          onClose={handleClose}
        >
          <Alert
            onClose={handleClose}
            severity={severity}
            sx={{ width: "100%" }}
          >
            {message}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
};

export default CompanyRequest;
